import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import type { Country } from 'hocs/countries/api/types';
import type { PhoneNumbersGroup } from 'hocs/telephony/api/types';

import styles from './foundItem.module.scss';

type PropsT = {
  group: PhoneNumbersGroup;
  country: Country;
  onBuyClickHandle: () => void;
};

const FoundGroup = ({ group, country, onBuyClickHandle }: PropsT) => {
  const { city_name, address_requirement } = group;
  const { country_code, country: country_name } = country;
  const addressRequirement = address_requirement?.requirement_type;

  const isAddressRequired =
    !!addressRequirement && addressRequirement !== 'worldwide';
  const addressWarningHead =
    addressRequirement === 'local'
      ? 'Local address or identification requirement'
      : 'National address or identification requirement';
  const addressWarningPopover =
    addressRequirement === 'local' ? (
      <span>
        This telephone number requires a local address in{' '}
        <span className={styles.name}>{city_name?.toLowerCase()}</span> (area
        code {group.area_code} ) ,{' '}
        <span className={styles.name}>{country_name.toLowerCase()}</span> before
        the number can be used.
      </span>
    ) : (
      <span>
        This telephone number requires a national address in{' '}
        <span className={styles.name}>{country_name.toLowerCase()}</span> before
        the number can be used.
      </span>
    );

  return (
    <div className={classnames(styles.wrapper, 'flags')}>
      <span className={classnames('flag', country_code.toLowerCase())} />
      <span className={styles.number}>
        (+{country.country_prefix}) {group.area_code} ...
      </span>
      {city_name && (
        <span className={styles.name}>{city_name.toLowerCase()}</span>
      )}
      {isAddressRequired && (
        <Tooltip
          head={addressWarningHead}
          content={addressWarningPopover}
          light
        >
          <span className={styles.warning}>
            <Icon name="exclamation" />
          </span>
        </Tooltip>
      )}
      <button className={styles.button} onClick={onBuyClickHandle}>
        Buy
      </button>
    </div>
  );
};

export default FoundGroup;
